export default __webpack_public_path__ + "static/media/Group 2978@2x.635c1b31.png";